<nz-spin [nzSpinning]="isPrintLoading || (loading$ | async)">
  <div class="drawer-form-wrapper without-bottom-cta" *ngIf="!!caseDetail">
    <div class="student-details-wrapper">
      <div class="student-img">
        <div class="action-dropdown">
          <button
            class="action-dropdown-btn"
            nz-dropdown
            [nzDropdownMenu]="menu"
            nzTrigger="click"
            [nzPlacement]="'bottomLeft'"
            type="button">
            <svg-icon
              [title]="'More options'"
              src="/assets/icon/icon-more.svg"
              class="icon s-20 more-icon"
              aria-label="More"></svg-icon>
          </button>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item nzClickHide="false" class="action-list-item">
                <button
                  type="button"
                  class="menu-item-button"
                  (click)="openstudentImageChangeDrawer()"
                  (keydown.enter)="openstudentImageChangeDrawer()">
                  <svg-icon
                    [title]="'Edit Student Image'"
                    src="/assets/icon/icon-pencil.svg"
                    class="icon s-16 fw-500"
                    aria-label="Pencil"></svg-icon>
                  <span class="text s-14">Edit</span>
                </button>
              </li>
              <li
                *ngIf="!!this.caseDetail.student.imageUrl"
                nz-menu-item
                nzClickHide="false"
                class="action-list-item">
                <button
                  type="button"
                  class="menu-item-button"
                  (click)="deleteStudentImage()"
                  (keydown.enter)="deleteStudentImage()">
                  <svg-icon
                    [title]="'Delete Student Image'"
                    src="/assets/icon/icon-trash.svg"
                    class="icon s-16 fw-500"
                    aria-label="Trash"></svg-icon>
                  <span class="text s-14">Delete</span>
                </button>
              </li>
            </ul>
          </nz-dropdown-menu>
        </div>
        <img
          *ngIf="caseDetail?.student?.imageUrl; else defaultImage"
          [src]="caseDetail.student.imageUrl"
          class="icon"
          [alt]="
            caseDetail.student.firstName + ' ' + caseDetail.student.lastName
          " />
        <ng-template #defaultImage>
          <svg-icon
            *ngIf="!caseDetail.student.imageUrl"
            src="/assets/icon/icon-student-avatar.svg"
            class="icon"
            aria-label="Student Avatar"></svg-icon>
        </ng-template>
      </div>
      <div class="student-details">
        <h3 class="title s-24">
          {{ caseDetail.student.firstName || '' }}
          {{ caseDetail.student.lastName || '' }}
        </h3>
        <p class="desc">{{ bipLable | reportLabel | async }}</p>
        <div class="badge-wrapper">
          <div class="badge">
            <span class="dot"></span>ID: {{ caseDetail.student.enrollId || '' }}
          </div>
          <div class="badge">
            <span class="dot orange"></span>Supervisor:
            {{ caseDetail.supervisorName }}
          </div>
          <div class="badge">
            <span class="dot"></span>Date of Birth:
            {{ caseDetail.student.dateOfBirth | date: 'MM/dd/yyyy' }}
          </div>
        </div>
      </div>
      <div class="cta-wrapper">
        <!-- Attachment button hidden per request; commented out (not
             deleted) so it can be restored easily if needed. -->
        <!--
        <button
          type="button"
          nz-button
          nzType="default"
          title="Manage Student Attachment"
          (click)="openInsightsAdminDrawer()">
          <svg-icon
            [title]="'Manage Student Attachment'"
            src="/assets/icon/icon-attachment.svg"
            class="icon s-20"
            aria-label="Attachment"></svg-icon>
        </button>
        -->
        <button
          *ngIf="allowManageTeamMember"
          type="button"
          nz-button
          nzType="default"
          title="Manage Student Team"
          (click)="openManageStudentTeamDrawer()">
          <svg-icon
            [title]="'Manage Student Team'"
            src="/assets/icon/icon-users.svg"
            class="icon s-20"
            aria-label="Users"></svg-icon>
        </button>
        <button
          *ngIf="allowEditCase"
          type="button"
          nz-button
          nzType="default"
          title="Edit Case Details"
          (click)="openEditCaseDrawer()">
          <svg-icon
            [title]="'Edit Case Details'"
            src="/assets/icon/icon-edit.svg"
            class="icon s-20"
            aria-label="Edit"></svg-icon>
        </button>
        <button
          *ngIf="hasActiveBehaviors()"
          type="button"
          nz-button
          nzType="default"
          title="Feedback"
          [ngClass]="{
            'primary-outlined':
              !caseDetail.isCaseFeedBackDue || caseDetail.isFrequencyOptional,
            'danger-btn':
              caseDetail.isCaseFeedBackDue && !caseDetail.isFrequencyOptional,
          }"
          (click)="openFeedbackDrawer()">
          Feedback
        </button>
      </div>
    </div>
    <div class="behavior-wrapper">
      <div class="drawer-cta-wrapper">
        <div class="left">
          <h3 class="text">Student Schedule :</h3>
          {{ caseDetail.student.scheduleTemplateName || '-' }}
        </div>
        <div class="cta-btns">
          <button
            type="button"
            nz-button
            nzType="default"
            [ngClass]="{
              'primary-outlined': isQuestionnaireValid,
              'danger-btn': !isQuestionnaireValid,
            }"
            title="Complete the questionnaires on this case's plan template"
            (click)="openInsightsAdminDrawer()">
            Questionnaire
          </button>
          <!-- Hidden in favor of the template-driven wizard below; commented
               out (not deleted) so this can be restored easily if needed. -->
          <!--
          <span
            *ngIf="allowManageBehavior"
            nz-tooltip
            [nzTooltipTitle]="
              isAddBehaviorDisabled
                ? 'Complete the required Hard-Stop questionnaire before adding a behavior'
                : null
            "
            [nzTooltipTrigger]="isAddBehaviorDisabled ? 'hover' : null">
            <button
              type="button"
              nz-button
              nzType="primary"
              [disabled]="isAddBehaviorDisabled"
              (click)="openDefineBehaviorDrawer()">
              Add New Behavior
            </button>
          </span>
          -->
          <span
            *ngIf="allowManageBehavior"
            nz-tooltip
            [nzTooltipTitle]="
              isChallengingBehaviorExcluded
                ? 'Challenging Behavior is not included in this case\'s plan template'
                : isAddBehaviorDisabled
                  ? 'Complete the required Hard-Stop questionnaire before adding a behavior'
                  : null
            "
            [nzTooltipTrigger]="isAddBehaviorDisabled ? 'hover' : null">
            <button
              type="button"
              nz-button
              nzType="primary"
              [disabled]="isAddBehaviorDisabled"
              (click)="openDefineBehaviorWizard()">
              Add New Behavior
            </button>
          </span>
          <span
            *ngIf="allowManageData"
            nz-tooltip
            [nzTooltipTitle]="addDataTooltipMessage"
            [nzTooltipTrigger]="isAddDataDisabled ? 'hover' : null">
            <button
              type="button"
              nz-button
              nzType="default"
              [disabled]="isAddDataDisabled"
              (click)="openAddDataDrawer()">
              Add Data
            </button>
          </span>
          <button
            *ngIf="caseDetail.caseBehaviors.length > 0"
            nz-button
            nz-dropdown
            [nzDropdownMenu]="casemenu"
            nzTrigger="click"
            [nzPlacement]="'bottomLeft'"
            nzType="default"
            type="button">
            <svg-icon
              [title]="'More options'"
              src="/assets/icon/icon-vertical-dots.svg"
              class="icon s-16"
              aria-label="Vertical Dots"></svg-icon>
          </button>
          <nz-dropdown-menu #casemenu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item nzClickHide="false" class="action-list-item">
                <button
                  type="button"
                  class="menu-item-button"
                  (click)="openPrintOptionsDrawer()"
                  (keydown.enter)="openPrintOptionsDrawer()">
                  <svg-icon
                    src="/assets/icon/icon-print.svg"
                    class="icon s-16 fw-500"
                    aria-label="Download"></svg-icon>
                  <span class="text s-14">{{
                    bipLable | reportLabel | async
                  }}</span>
                </button>
              </li>
              <li nz-menu-item nzClickHide="false" class="action-list-item">
                <button
                  type="button"
                  class="menu-item-button"
                  (click)="openDataLogDrawer()"
                  (keydown.enter)="openDataLogDrawer()">
                  <svg-icon
                    src="/assets/icon/icon-eye.svg"
                    class="icon s-16 fw-500"
                    aria-label="Eye"></svg-icon>
                  <span class="text s-14">Data Log</span>
                </button>
              </li>
              <li nz-menu-item nzClickHide="false" class="action-list-item">
                <button
                  type="button"
                  class="menu-item-button"
                  (click)="openReportManagerDrawer()"
                  (keydown.enter)="openReportManagerDrawer()">
                  <svg-icon
                    src="/assets/icon/icon-email.svg"
                    class="icon s-16 fw-500"
                    aria-label="Email"></svg-icon>
                  <span class="text s-14">Progress Report Manager</span>
                </button>
              </li>
              <li nz-menu-item nzClickHide="false" class="action-list-item">
                <button
                  type="button"
                  class="menu-item-button"
                  (click)="printQuickGuide()"
                  (keydown.enter)="printQuickGuide()">
                  <svg-icon
                    src="/assets/icon/icon-download.svg"
                    class="icon s-16 fw-500"
                    aria-label="Download"></svg-icon>
                  <span class="text s-14">Quick Guide to Plan</span>
                </button>
              </li>
              <li nz-menu-item nzClickHide="false" class="action-list-item">
                <button
                  type="button"
                  class="menu-item-button"
                  (click)="openFAQDrawer()"
                  (keydown.enter)="openFAQDrawer()">
                  <svg-icon
                    src="/assets/icon/icon-file.svg"
                    class="icon s-16 fw-500"
                    aria-label="File"></svg-icon>
                  <span class="text s-14">Reference Material</span>
                </button>
              </li>
            </ul>
          </nz-dropdown-menu>
        </div>
      </div>
      <app-case-plan-status-banner
        [status]="casePlanStatus?.questionnaire"
        [behaviorList]="casePlanStatus?.behaviorList"
        [caseBehaviors]="caseDetail.caseBehaviors"
        [templateName]="
          bipTemplate?.templateName
        "></app-case-plan-status-banner>
      <app-behavior-list
        *ngIf="caseDetail.caseBehaviors.length > 0; else nodata"
        [caseDetail]="caseDetail"
        [allowManageBehavior]="allowManageBehavior"
        [allowManageAssessment]="allowManageAssessment"
        [allowManageStrategy]="allowManageStrategy"
        (listUpdated)="getCaseDetail()"></app-behavior-list>
    </div>

    <!-- render this if there is no behavior available -->
    <ng-template #nodata>
      <app-no-data
        [title]="'No Behavior'"
        [desc]="'No Behavior Defined'"
        [icon]="'/assets/icon/icon-face-happy.svg'">
      </app-no-data>
    </ng-template>
  </div>
</nz-spin>

<!-- convert to bip modal -->
<nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="modalHeaderTemplate"
  [nzFooter]="modalFooterTemplate"
  (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleOk()"
  nzWidth="400px"
  nzCentered>
  <ng-template #modalHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon modal-icon-orange">
        <svg-icon
          src="/assets/icon/icon-print.svg"
          class="icon s-20"
          aria-label="Print"></svg-icon>
      </div>
      <h3 class="ant-modal-title">Convert to BIP</h3>
      <p class="text s-14 fw-400 ant-modal-subtitle">
        Are you sure you want to convert this to BIP
      </p>
      <!-- circle-pattern -->
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"
        aria-label="Modal Circle"></svg-icon>
    </div>
  </ng-template>

  <ng-template #modalFooterTemplate>
    <div class="modal-footer">
      <button
        nz-button
        nzType="default"
        (click)="handleCancel()"
        class="display-flex justify-content-center">
        Cancel
      </button>
      <button
        nz-button
        nzType="primary"
        (click)="handleOk()"
        class="display-flex justify-content-center">
        Confirm
      </button>
    </div>
  </ng-template>
</nz-modal>

<ng-template #drawerTitleTpl>
  <div class="drawer-title-wrapper">
    <div class="back-button">
      <button nz-button nzType="default" type="button">
        <svg-icon
          src="/assets/icon/icon-arrow.svg"
          class="icon s-20"
          aria-label="Arrow"></svg-icon>
      </button>
    </div>
    <div>
      <h3 class="ant-drawer-title">Manage Student Team</h3>
      <nz-breadcrumb nzSeparator=">">
        <nz-breadcrumb-item>
          <span>
            {{ getFullName() }}
          </span>
        </nz-breadcrumb-item>
        <nz-breadcrumb-item
          (click)="closeMangeStudentTeamDrawer()"
          (keydown.enter)="closeMangeStudentTeamDrawer()">
          <a tabindex="0">Manage Student Team</a>
        </nz-breadcrumb-item>
      </nz-breadcrumb>
    </div>
  </div>
</ng-template>

<app-confirm-dialog
  [isVisible]="deleteStudentConfirmDialog"
  [title]="'Delete Student Image'"
  [message]="'Are you sure you want to delete Student Image?'"
  [iconSrc]="'/assets/icon/icon-trash-red.svg'"
  [iconColor]="'red'"
  [cancelText]="'Cancel'"
  [confirmText]="'Delete'"
  (confirmed)="handleDeleteStudent()"
  (cancelled)="handleClose()"
  (closed)="handleClose()">
</app-confirm-dialog>

<ng-template #drawerBehaviorTitleTpl>
  <div class="drawer-title-wrapper">
    <div class="back-button">
      <button
        nz-button
        nzType="default"
        type="button"
        (click)="closeBehaviorDrawer()">
        <svg-icon
          src="/assets/icon/icon-arrow.svg"
          class="icon s-20"
          aria-label="Arrow"></svg-icon>
      </button>
    </div>
    <div>
      <ng-container
        *ngIf="
          getSectionHelpText(tileSection.Details) as behaviorHelpText;
          else viewBehaviorTitleOnlyTpl
        ">
        <div class="drawer-title-row">
          <h3 class="ant-drawer-title">Define Behavior</h3>
          <app-help-text [text]="behaviorHelpText"></app-help-text>
        </div>
      </ng-container>
      <ng-template #viewBehaviorTitleOnlyTpl>
        <h3 class="ant-drawer-title">Define Behavior</h3>
      </ng-template>
      <nz-breadcrumb nzSeparator=">">
        <nz-breadcrumb-item>
          <span> {{ caseDetail?.student?.firstName }}'s </span>
        </nz-breadcrumb-item>
        <nz-breadcrumb-item
          (click)="closeBehaviorDrawer()"
          (keydown.enter)="closeBehaviorDrawer()">
          <a tabindex="0">Define Behavior</a>
        </nz-breadcrumb-item>
      </nz-breadcrumb>
    </div>
  </div>
</ng-template>
<ng-template #drawerBehaviorWizardTitleTpl>
  <div class="drawer-title-wrapper">
    <div class="back-button">
      <button
        nz-button
        nzType="default"
        type="button"
        (click)="closeDefineBehaviorWizard()">
        <svg-icon
          src="/assets/icon/icon-arrow.svg"
          class="icon s-20"
          aria-label="Arrow"></svg-icon>
      </button>
    </div>
    <div>
      <ng-container
        *ngIf="
          getSectionHelpText(tileSection.Details) as behaviorWizardHelpText;
          else viewBehaviorWizardTitleOnlyTpl
        ">
        <div class="drawer-title-row">
          <h3 class="ant-drawer-title">Define Behavior</h3>
          <app-help-text [text]="behaviorWizardHelpText"></app-help-text>
        </div>
      </ng-container>
      <ng-template #viewBehaviorWizardTitleOnlyTpl>
        <h3 class="ant-drawer-title">Define Behavior</h3>
      </ng-template>
      <nz-breadcrumb nzSeparator=">">
        <nz-breadcrumb-item>
          <span> {{ caseDetail?.student?.firstName }}'s </span>
        </nz-breadcrumb-item>
        <nz-breadcrumb-item
          (click)="closeDefineBehaviorWizard()"
          (keydown.enter)="closeDefineBehaviorWizard()">
          <a tabindex="0">Define Behavior</a>
        </nz-breadcrumb-item>
      </nz-breadcrumb>
    </div>
  </div>
</ng-template>
<ng-template #drawerAttachment>
  <app-drawer-header
    [title]="'Attachment'"
    subtitle="Attachments"
    [breadcrumbText]="caseDetail?.student?.firstName || ''"
    (drawerClose)="closeInsightAdminDrawer()">
  </app-drawer-header>
</ng-template>

<ng-template #addDataTpl>
  <app-drawer-header
    [title]="'Data'"
    subtitle="Data"
    [breadcrumbText]="caseDetail?.student?.firstName || ''"
    (drawerClose)="closeAddDataDrawer()">
  </app-drawer-header>
</ng-template>

<ng-template #faqTpl>
  <app-drawer-header
    [title]="'Frequently Asked Questions'"
    (drawerClose)="CloserFAQDrawer()">
  </app-drawer-header>
</ng-template>

<ng-template #feedbackDataTpl>
  <app-drawer-header
    [title]="'Feedback'"
    subtitle="Feedback"
    [breadcrumbText]="caseDetail?.student?.firstName || ''"
    (drawerClose)="closefeedbackFormDrawer()">
  </app-drawer-header>
</ng-template>

<app-confirm-dialog
  [isVisible]="showReportConfirmDialog"
  title="{{
    printReportData?.isEditMode ? 'Report Updated' : 'Report Created'
  }}"
  [message]="reportModelMsg"
  [iconSrc]="'/assets/icon/icon-check-circle.svg'"
  [iconColor]="'green'"
  [cancelText]="'Close'"
  [primaryButtonClass]="'btn btn-primary'"
  [confirmText]="'Download'"
  [loading]="isPrintLoading"
  (confirmed)="printReport()"
  (cancelled)="cancelReport()"
  (closed)="cancelReport()">
</app-confirm-dialog>

<ng-template #reportMngerTpl>
  <app-drawer-header
    [title]="'Report Manager'"
    [subtitle]="'Report Manager'"
    breadcrumbText="{{ caseDetail?.student?.firstName }}'s"
    (drawerClose)="closeReportDrawer()">
  </app-drawer-header>
</ng-template>

<ng-template #printOptionTpl>
  <app-drawer-header
    [title]="'Download Options'"
    [subtitle]="'Download Options'"
    breadcrumbText="{{ caseDetail?.student?.firstName }}'s"
    (drawerClose)="closePrintOptionsDrawer()">
  </app-drawer-header>
</ng-template>

<ng-template #studentImageTitleTpl>
  <app-drawer-header
    [title]="'Profile Image'"
    (drawerClose)="closeStudentImageDrawer()">
  </app-drawer-header>
</ng-template>
